import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Angulartics2GoogleAnalytics } from 'angulartics2';
import { filter } from 'rxjs/operators';

import { SupportComponent } from './support/support.component';

@Component({
    selector: 'app-core',
    templateUrl: './core.component.html',
    styleUrls: ['./core.component.scss'],
})
export class CoreComponent {
    isMenuCollapsed = true;

    constructor(angulartics2: Angulartics2GoogleAnalytics, private modalService: NgbModal, private router: Router) {
        angulartics2.startTracking();

        if (typeof window.Intercom !== 'function') {
            let i: any = function () {
                i.c(arguments);
            };
            i.q = [];
            i.c = (args: any) => {
                i.q.push(args);
            };
            window['Intercom'] = i;

            let s = document.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = 'https://widget.intercom.io/widget/p4t7zgsg';
            let x = document.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
        }

        this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
            (<any>window).scrollTo(0, 0);
        });
    }

    openSupportModal() {
        const modalRef = this.modalService.open(SupportComponent, { backdrop: 'static' });

        modalRef.componentInstance.name = 'PaymentSupport';

        modalRef.result
            .then(
                () => {},
                () => {},
            )
            .finally(() => {
                Intercom('shutdown');
                Intercom('hide');
            });
    }
}
